import React, { Fragment, lazy, Suspense, useRef, useEffect } from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const MiniCart = () => {
    const dispatch = useDispatch();
    const { orderRows, orderTotal, quantity, showInfo, checkoutUrl, deliveryCost } = useSelector(
        (state) => state.cart
    );
    const { channelIsB2B } = useSelector((state) => state.channels);
    const isInCheckout = false;
    const onToggle = () => dispatch(toggle());

    const toggleRef = useRef(null);

    const handleClickOutside = (e) => {
        if (toggleRef.current && !toggleRef.current.contains(e.target) && showInfo) {
            onToggle();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showInfo]);

    const MiniCartProducts = lazy(() => import('./MiniCartProducts'));

    return (
        <div className="cart cart--mini">
            <a
                className={`cart__link--block ${showInfo ? 'disabled-link' : ''}`}
                rel="nofollow"
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onToggle();
                }}
            >
                <i className="cart__icon">
                    <span className="cart__quantity">{quantity}</span>
                </i>
            </a>
            <div
                className={`cart__info-extended ${!showInfo && !isInCheckout ? 'cart__info--hidden' : ''}`} ref={toggleRef}
            >
                {!isInCheckout && (
                    <span className="cart__close-button-extended" onClick={() => onToggle()}></span>
                )}
                {orderRows.length ? (
                    <Fragment>
                        <div className="cart__info-heading">
                            <h2>
                                {translate('common.minicart.newheading')} ({quantity})
                            </h2>
                        </div>
                        {showInfo && (
                            <div className="cart__product-items">
                                {orderRows.map((orderRow) => {
                                    return (
                                        <Suspense key={orderRow.rowSystemId} fallback={null}>
                                            <MiniCartProducts
                                                product={orderRow}
                                            />
                                        </Suspense>
                                    );
                                })}
                            </div>
                        )}
                        <div className="cart__summary">
                            <div className="cart__summary__info-row">
                                <div className="cart__split-row">
                                    <Fragment>
                                        {channelIsB2B ? (
                                            <span>
                                                {translate('common.minicart.deliverycosttextb2b')}
                                            </span>
                                        ) : (
                                            <span>{translate('common.minicart.deliverycosttext')}</span>
                                        )}
                                        {isInCheckout && <span>{deliveryCost}</span>}
                                    </Fragment>
                                </div>
                            </div>
                            <div className="cart__summary__info-row">
                                <div className="cart__split-row">
                                    {channelIsB2B ? (
                                        <span>{translate('common.minicart.totalexvat')}</span>
                                    ) : (
                                        <span>{translate('common.minicart.totalincvat')}</span>
                                    )}
                                    <span className="cart__split-row__total">{orderTotal}</span>
                                </div>
                            </div>
                            <a href={checkoutUrl} className="cart__checkout-button-extended">
                                {translate('common.minicart.tocheckout')}
                            </a>
                        </div>
                    </Fragment>
                ) : (
                    <h2>{translate('common.minicart.emptyheading')}</h2>
                )}
            </div>          
        </div>
    );
};

export default MiniCart;
